<template>
  <div class="box box-4" :class="{ 'ani-scale': !isMobileSize }" @click="$emit('openVideo', 4)">
    <img class="img-4" :src="img4" alt="" />
    <img class="add-icon" :src="addIcon" alt="" />
    <div class="title">{{ $t('keypalTwo.introduce.desc_6') }}</div>
    <div class="desc">{{ $t('keypalTwo.introduce.desc_7') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isMobileSize']),
    img4() {
      return require('../../assets/images/keypal-two/introduce-4.png');
    },
    addIcon() {
      return require('../../assets/images/keypal-two/add-1.png');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./card.scss');
.box-4 {
  width: 384px;
  height: 213px;

  .img-4 {
    width: 105px;
    height: 105px;
    position: absolute;
    top: 20px;
    right: 24px;
  }
}

@media screen and (max-width: 1200px) {
  .box-4 {
    width: calc(384 / 1300 * 100vw);
    height: calc(213 / 1300 * 100vw);
    .img-4 {
      width: calc(105 / 1300 * 100vw);
      height: calc(105 / 1300 * 100vw);
    }
  }
}

@media screen and (max-width: 767px) {
  .box-4 {
    width: 276px;
    height: auto;
    .img-4 {
      width: 115px;
      height: 115px;
      position: absolute;
      left: 50%;
      top: 165px;
      transform: translateX(-50%);
    }
  }
}
</style>
